import React from "react";
import { StyledHeaderWrapper } from "./styled";

function Header({ brandConfig }) {
  return (
    <StyledHeaderWrapper
      customFont={
        brandConfig && brandConfig !==null && brandConfig.google_font_family !== null &&  brandConfig.google_font_family !== ''
          ? brandConfig.google_font_family
          : "Poppins,sans-serif"
      }
    >
      <div style={{ minWidth: "50px" }}>
        <img
          src={brandConfig && brandConfig !==null && brandConfig.brand_logo}
          alt="Brand logo"
          className="brand-logo"
        />
      </div>
    </StyledHeaderWrapper>
  );
}

export default Header;
